import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ATCIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M13.0015 20.4838C12.6573 20.8279 12.2309 21 11.7222 21C11.2134 21 10.787 20.8279 10.4429 20.4838L3.23838 13.2793C2.89424 12.9352 2.72217 12.5087 2.72217 12C2.72217 11.4913 2.89424 11.0648 3.23838 10.7207L10.4429 3.51621C10.787 3.17207 11.2134 3 11.7222 3C12.2309 3 12.6573 3.17207 13.0015 3.51621L20.206 10.7207C20.5501 11.0648 20.7222 11.4913 20.7222 12C20.7222 12.5087 20.5501 12.9352 20.206 13.2793L13.0015 20.4838ZM11.7222 19.2045L18.9267 12L11.7222 4.79551L4.51768 12L11.7222 19.2045ZM10.8244 12.8978H12.6199V7.51122H10.8244V12.8978ZM11.7222 15.591C11.9765 15.591 12.1899 15.5048 12.3623 15.3325C12.534 15.1607 12.6199 14.9476 12.6199 14.6933C12.6199 14.4389 12.534 14.2255 12.3623 14.0532C12.1899 13.8814 11.9765 13.7955 11.7222 13.7955C11.4678 13.7955 11.2547 13.8814 11.083 14.0532C10.9106 14.2255 10.8244 14.4389 10.8244 14.6933C10.8244 14.9476 10.9106 15.1607 11.083 15.3325C11.2547 15.5048 11.4678 15.591 11.7222 15.591Z'
                fill='currentColor'
            />
        </>
    ),
})

ATCIcon.displayName = 'ATCIcon'
